import { useCallback } from "react";
import { useSidebarShallowStore } from "../store/sidebar-store";

export const useUpdateEnduserInSidebar = () => {
  const { contentType, contentTypeData, isOpen, openSidebar } = useSidebarShallowStore(
    "isOpen",
    "contentTypeData",
    "contentType",
    "openSidebar"
  );

  const updateEnduserInSidebar = useCallback(
    (enduserId: string | undefined) => {
      if (!isOpen) return;
      if (!enduserId) return;
      if (contentType !== "ContactDetails") return;
      if (contentTypeData.ContactDetails?.enduserId === enduserId) return;
      openSidebar("ContactDetails", { enduserId });
    },
    [contentType, contentTypeData.ContactDetails?.enduserId, isOpen, openSidebar]
  );

  return updateEnduserInSidebar;
};
